import axios from 'axios'

function getDefaultBusinessId() {
	const value = process.env.REACT_APP_DEFAULT_BUSINESS_ID
	if (!value) {
		throw new Error('REACT_APP_DEFAULT_BUSINESS_ID is not configured')
	}
	return value
}

export const AUTH_URL = `${process.env.REACT_APP_API_URL}/auth`
export const GET_USER_BY_ACCESSTOKEN_URL = `${process.env.REACT_APP_API_URL}/verify_token`

const ROLE_LEVEL_BY_NAME = {
	owner: 1,
	ceo: 2,
	vp: 3,
	director: 4,
	manager: 4,
}

function normalizePermissions(permissions) {
	if (typeof permissions === 'string') return permissions
	if (Array.isArray(permissions)) return permissions.join(', ')
	if (!permissions || typeof permissions !== 'object') return ''

	const labels = []
	if (permissions.create) labels.push('create')
	if (permissions.read) labels.push('read')
	if (permissions.update) labels.push('update')
	if (permissions.delete) labels.push('delete')
	if (permissions.read_all || permissions.readAll) labels.push('readall')
	if (permissions.modify_all || permissions.modifyAll) labels.push('modifyall')
	return labels.join(', ')
}

export function normalizeAuthUser(user = {}) {
	const payload = user.payload || user
	const roleName = payload.role_name || payload.roleName || ''
	const roleLevel =
		Number(payload.role_level ?? payload.roleLevel) ||
		ROLE_LEVEL_BY_NAME[String(roleName).toLowerCase()] ||
		null
	const permission = normalizePermissions(
		payload.permission || payload.permissions,
	)

	return {
		...payload,
		id: payload.id || payload.account_id || payload.firebase_uid,
		account_id: payload.account_id || payload.firebase_uid,
		local_profile_id: payload.local_profile_id || payload.localProfileId,
		localProfileId: payload.localProfileId || payload.local_profile_id,
		business_id: payload.business_id || payload.businessId,
		businessId: payload.businessId || payload.business_id,
		role_level: roleLevel,
		roleLevel,
		role_name: roleName,
		roleName,
		permission,
		permissions: permission || payload.permissions,
		is_admin: payload.is_admin ?? payload.isAdmin,
		isAdmin: payload.isAdmin ?? payload.is_admin,
		is_owner: payload.is_owner ?? payload.isOwner,
		isOwner: payload.isOwner ?? payload.is_owner,
	}
}

export function login_using_refresh_token(data) {
	return axios.post(AUTH_URL + '/login_using_refresh_token', data)
}

export async function login(data) {
	return await axios.post(
		AUTH_URL + '/login_with_email_and_password',
		{
			...data,
			business_id: getDefaultBusinessId(),
		}
	)
}

export async function login_with_keys(publicKey, privateKey) {
	return await axios.post(AUTH_URL + '/login-with-keys', {
		publicKey,
		privateKey,
	})
}

export async function getUserByToken(authToken) {
	const config = authToken
		? { headers: { Authorization: `Bearer ${authToken}` } }
		: undefined
	const user = await axios.get(GET_USER_BY_ACCESSTOKEN_URL, config)
	return normalizeAuthUser(user)
}
